/* tslint:disable:jsx-no-lambda */
import debounce from 'lodash-es/debounce';
import * as React from 'react';
import AsyncDialogLoader from '../asyncDialogLoader/asyncDialogLoader';
import Content from '../content/content';
import DeleteFolderDialogAsync from '../dialogs/deleteFolderDialogAsync';
import { getLocalizedStringStore } from 'owa-localize';
import { getCommands } from 'owa-mail-hotkeys/lib/utils/MailModuleHotKeys';
import { DebugDialogAsync } from '../../../owa-debug';
import type { SearchBoxContainerHandle } from 'owa-search/lib/types/SearchBoxContainerHandle';
import { useGlobalHotkey } from 'owa-hotkeys';
import { lifecycle, ReactLifeCycleFunctionsThisArguments } from 'recompose';
import { Provider } from 'react-redux';
import type { Store } from 'redux';
import { isFeatureEnabled } from 'owa-feature-flags';
import { hasQueryStringParameter } from 'owa-querystring';

import './app.scss';

export interface AppProps {
    store: Store<{}>;
    searchBoxRef: React.RefObject<SearchBoxContainerHandle>;
}

export function App({ store, searchBoxRef }: AppProps) {
    useGlobalHotkey(getCommands().gotoSearch, () => searchBoxRef.current.setFocus());

    return (
        <Provider store={store}>
            <Content store={store} />
            <DeleteFolderDialogAsync />
            <AsyncDialogLoader store={store} />
            {isDebugVisible() && <DebugDialogAsync store={store} />}
        </Provider>
    );
}

function componentDidMount(this: ReactLifeCycleFunctionsThisArguments<{}, {}>): void {
    // Whenever strings change, we re-render the app
    // We debounce as we only want to re-render when all changes to the observableMap has been done.
    const forceUpdateDebounced = debounce(() => {
        this.forceUpdate();
    }, 0);
    getLocalizedStringStore().localizedStrings.observe(() => {
        forceUpdateDebounced();
    });
}

function isDebugVisible(): boolean {
    return isFeatureEnabled('ring-dogfood') || hasQueryStringParameter('debug');
}

export default lifecycle<{}, {}, {}>({ componentDidMount })(App);
